
export function getBanks(state = {
    banks: null,
    isPending: true,
    isSubmitSuccess: false,
    }, action){
    switch(action.type){
        case 'GET_BANKS_RESET':
            return Object.assign({}, state, {
                isPending: false,
                isSubmitSuccess: false,
            })
        case 'GET_BANKS_FULFILLED':
            return Object.assign({}, state, {
                banks:  action.payload.data.results.banks,
                isPending: false,
                isSubmitSuccess: false,
            })
        case 'UPDATE_BANK_PENDING': 
            return Object.assign({}, state, {
                isPending: true,
                isSubmitSuccess: false,
            })            
        case 'UPDATE_BANK_FULFILLED': 
            return Object.assign({}, state, {
                isSubmitSuccess: true,
                isPending: false,
            })
        default:
        return state
    }
}